import { render, staticRenderFns } from "./StoryTechnologies.vue?vue&type=template&id=5aa2fab9&scoped=true&"
import script from "./StoryTechnologies.vue?vue&type=script&lang=js&"
export * from "./StoryTechnologies.vue?vue&type=script&lang=js&"
import style0 from "./StoryTechnologies.vue?vue&type=style&index=0&id=5aa2fab9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa2fab9",
  null
  
)

export default component.exports